import { ShipmentDirection } from '@/services/transponders/types';

export const SHIPMENT_DIRECTION_WORDING: Record<ShipmentDirection, string> = {
  IN: 'To FleetIT',
  OUT: 'From FleetIT',
};

export default {};
